import {z} from 'zod';

import {reportFiltersSchema} from './ReportFiltersSchema';

export const marginByMonthSchema = z.object({
  month: z.string(),
  labourMargin: z.number(),
  materialMargin: z.number(),
  dmmMargin: z.number(),
  totalMargin: z.number(),
});

export type MarginByMonth = z.infer<typeof marginByMonthSchema>;

export const marginSummarySchema = marginByMonthSchema.omit({month: true});

export type MarginSummary = z.infer<typeof marginSummarySchema>;

export const marginByMonthResponseSchema = z.object({
  data: z.array(marginByMonthSchema),
  summary: marginSummarySchema,
  filters: reportFiltersSchema,
});

export type MarginByMonthResponse = z.infer<typeof marginByMonthResponseSchema>;
